import gql from 'graphql-tag';

// Multilingual v3: the project's languages for its settings (founder 19.10.2026); sysadmin-only in Hasura.
export default gql`
query getProjectLanguages($projectId: Int!) {
  projects_by_pk(project_id: $projectId) {
    project_id
    language {
      language_id
      handle
    }
  }
  project_languages(where: { project_id: { _eq: $projectId } }, order_by: { sort: asc }) {
    project_language_id
    online
    language {
      language_id
      handle
    }
  }
  languages {
    language_id
    handle
  }
}
`;
